import moment from 'moment'

import { parseLogJson } from '../../../../Pages/Logs/logHelper'
import { primary_color } from '../../../../Helper/uiHelper'

const deletedLockerFromLog = (data, originalRows, updatedRows) => {
  if (data?.location_template_logs) {
    const match = String(data.location_template_logs).match(/Deleted Locker\s+(.+)$/i)
    if (match?.[1]) {
      return { name: match[1].trim(), location: null, id: null }
    }
  }

  const original = Array.isArray(originalRows) ? originalRows : []
  const updated = Array.isArray(updatedRows) ? updatedRows : []
  if (original.length === 1 && updated.length === 0) {
    return original[0]
  }
  if (original.length > updated.length) {
    const updatedIds = new Set(updated.map((row) => row?.id))
    return original.find((row) => !updatedIds.has(row?.id)) || original[original.length - 1]
  }
  return original[original.length - 1] || updated[updated.length - 1]
}

const ShowDifference = ({ data, original_data, updated_data, onExpand }) => {
  const deleted = deletedLockerFromLog(data, original_data, updated_data)

  return (
    <div>
      <div className='permission-table'>
        <div className='mb-2 cursor-pointer' onClick={() => onExpand()}>
          <i class='fa-sharp fa-solid fa-arrow-left  m-3'></i>
          Go Back
        </div>
        <div className={`permission-header`} style={{ color: primary_color }}>
          <div className='d-flex align-items-center'>
            <div style={{ flex: 1 }}>
              <span className='font-weight-bold'>{data?.updated_by}</span>
              {` deleted a locker`}
            </div>
            {data?.updated_at && <div>{moment.utc(data?.updated_at).format('MMM D  YYYY, HH:mm')}</div>}
          </div>
        </div>
        <div className='px-5 py-4'>
          {data?.location_template_status ? (
            <div className='mb-3'>
              <div className='font-weight-bold body2' style={{ color: primary_color }}>
                Change type
              </div>
              <div className='subtitle1'>{data.location_template_status}</div>
            </div>
          ) : null}
          {data?.location_template_logs ? (
            <div className='mb-3'>
              <div className='font-weight-bold body2' style={{ color: primary_color }}>
                Summary
              </div>
              <div className='subtitle1'>{data.location_template_logs}</div>
            </div>
          ) : null}
          {deleted?.location ? (
            <div className='mb-3'>
              <div className='font-weight-bold body2' style={{ color: primary_color }}>
                Block
              </div>
              <div className='subtitle1'>{deleted.location}</div>
            </div>
          ) : null}
          {deleted?.name != null ? (
            <div className='mb-3'>
              <div className='font-weight-bold body2' style={{ color: primary_color }}>
                Locker number
              </div>
              <div className='subtitle1'>{deleted.name}</div>
            </div>
          ) : null}
          {deleted?.id ? (
            <div className='mb-3'>
              <div className='font-weight-bold body2' style={{ color: primary_color }}>
                Locker ID
              </div>
              <div className='subtitle1'>{deleted.id}</div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}

const DeleteLockerLog = ({ data, onExpand, expandedId }) => {
  const original_data = parseLogJson(data?.original_data, [])
  const updated_data = parseLogJson(data?.updated_data, [])
  const deleted = deletedLockerFromLog(data, original_data, updated_data)
  const summary = data?.location_template_logs || (deleted?.name != null ? `Deleted locker ${deleted.name}` : 'Deleted locker')

  if (expandedId) {
    return (
      <ShowDifference
        data={data}
        onExpand={onExpand}
        updated_data={updated_data}
        original_data={original_data}
      />
    )
  }
  return (
    <div className='d-flex align-items-center p-3' style={{ borderBottom: '1px solid #e0e0e0' }}>
      <div>
        <i
          class='fa-solid fa-arrow-up-right-from-square mr-2 cursor-pointer'
          style={{ color: primary_color }}
          onClick={() => {
            onExpand(data?.id)
          }}></i>
      </div>
      <div style={{ flex: 1 }}>
        <span className='font-weight-bold'>{data?.updated_by}</span>
        {` ${summary}`}
      </div>
      {data?.updated_at && <div>{moment.utc(data?.updated_at).format('MMM D  YYYY, HH:mm')}</div>}
    </div>
  )
}

export default DeleteLockerLog
